import script from './button.vue_vue_type_script_lang.mjs';
export { default } from './button.vue_vue_type_script_lang.mjs';
import { render } from './button.vue_vue_type_template_id_802c5c76_lang.mjs';

script.render = render;
script.__file = "packages/components/button/src/button.vue";
//# sourceMappingURL=button2.mjs.map
